<main class="flex flex-column flex-grow-1 px-4 pb-4">
  <header
    class="flex align-items-center justify-content-between bg-primary py-2 px-3 lg:w-11 xl:w-8 lg:align-self-center sticky z-1 my-3"
    style="top: 1rem"
  >
    <img src="logo.svg" alt="jobfixers logo" />

    <ul class="list-none p-0 m-0 gap-3 text-sm align-items-center text-center hidden lg:flex">
      <li><a href="https://work.jobfixers.be">Jobs</a></li>
      <li><a href="https://join.jobfixers.be" target="_blank">Werken bij ons</a></li>
      <li><a href="https://www.jobfixers.be/nl/bedrijven">Voor werkgevers</a></li>
      <li><a href="https://www.jobfixers.be/nl/onze-kantoren">Vind een kantoor</a></li>
      <li><a href="https://www.jobfixers.be/nl/rally">Rally team</a></li>
      <li><a href="https://www.jobfixers.be/nl/contact">Contact</a></li>
    </ul>

    <p-button class="lg:hidden" (click)="isSidemenuOpened.set(true)" size="small">
      <svg width="24px" height="24px">
        <use href="icons/menu.svg#menu-icon" />
      </svg>
    </p-button>
  </header>

  <div class="lg:w-11 xl:w-8 lg:align-self-center">
    <router-outlet></router-outlet>

    <section class="grid grid-nogutter align-items-start row-gap-3 mt-3">
      <div class="col-12 md:col-4 bg-primary p-0 shadow-4">
        <img ngSrc="rally.png" fill priority class="static" />

        <h3 class="px-3">Wist je dit al?</h3>

        <article class="px-3 text-sm font-medium">
          <p>Jobfixers is trotse hoofdsponsor van het Jobfixers Rally Team!</p>
          <p>
            Net als in de rally draait het bij ons om de juiste weg te kiezen met snelheid en zonder
            stuurfout.
          </p>
          <p>
            Wij helpen arbeiders niet zomaar aan een job — we helpen jou aan een job die je écht wil
            doen. Met aandacht voor wat voor jou belangrijk is, en we begeleiden je tot op je
            bestemming.
          </p>
          <p>
            Start je via ons? Dan krijg je een exclusief rallypakket met een T-shirt, rally-zwemzak
            en poster cadeau.
          </p>
          <p>Vul dit formulier in of bel ons op <a href="callto:092100909">09/210 09 09</a></p>
          <p>Jobfixers -- Samen op weg naar jouw ideale job.</p>
        </article>

        <a
          pButton
          severity="contrast"
          class="ml-3 mb-4 mt-2 no-underline"
          href="https://www.jobfixers.be/nl#rally-form"
        >
          <span>Zoek een job!</span>
          <svg width="24px" height="24px" fill="var(--p-secondary-500)">
            <use href="icons/chevron_right.svg#chevron_right-icon" />
          </svg>
        </a>
      </div>

      <div class="col-12 md:col-7 md:col-offset-1 bg-white p-4 shadow-4">
        <img src="logo.svg" alt="jobfixers logo" />

        <h3 class="flex align-items-center gap-1 gap-3 pl-1">
          <svg width="30px" height="30px" fill="var(--p-secondary-500)">
            <use href="icons/done.svg#done-icon" />
          </svg>
          Wij luisteren naar jou
        </h3>
        <p class="border-left-1 ml-3 pl-5 text-sm" style="border-color: var(--p-secondary-500)">
          Tell me your dream, want wij gaan die voor jou realiseren.<br />
          Wij achterhalen wat je echt wil, wij matchen de juiste kandidaat in het juiste bedrijf met
          de juiste job!
        </p>

        <h3 class="flex align-items-center gap-1 gap-3 pl-1">
          <svg width="30px" height="30px" fill="var(--p-secondary-500)">
            <use href="icons/done.svg#done-icon" />
          </svg>
          Optie vast contract
        </h3>
        <p class="border-left-1 ml-3 pl-5 text-sm" style="border-color: var(--p-secondary-500)">
          JobFIXers is het enige uitzend-selectiebedrijf dat zich 100% focust op vast werk en
          bovendien zorgen we dat de kandidaat de beste condities krijgt.<br />
          Een job met de optie op een vast contract is een garantie die we de kandidaat sowieso
          geven.
        </p>

        <h3 class="flex align-items-center gap-1 gap-3 pl-1">
          <svg width="30px" height="30px" fill="var(--p-secondary-500)">
            <use href="icons/done.svg#done-icon" />
          </svg>
          We leave no-one behind
        </h3>
        <p class="border-left-1 ml-3 pl-5 text-sm" style="border-color: var(--p-secondary-500)">
          We laten de kandidaat nooit in de steek en we doen alles voor hem/haar!<br />
          Wij vinden een job voor iedereen. We luisteren naar zijn/haar dromen, achterhalen de
          talenten en gaan tot het uiterste om de kandidaat aan de best betalende job te helpen.
        </p>

        <h3 class="flex align-items-center gap-1 gap-3 pl-1">
          <svg width="30px" height="30px" fill="var(--p-secondary-500)">
            <use href="icons/done.svg#done-icon" />
          </svg>
          Jobs in heel Vlaanderen!
        </h3>
        <p class="ml-3 pl-5 text-sm">
          Met kantoren verspreid over West-Vlaanderen, Oost-Vlaanderen, Antwerpen en Vlaams-Brabant,
          bedienen onze FIXers de kandidaat op zijn wenken!
        </p>

        <a pButton severity="contrast" class="mt-2 no-underline" href="https://www.jobfixers.be/">
          <span>Ontdek JobFIXers!</span>
          <svg width="24px" height="24px" fill="var(--p-secondary-500)">
            <use href="icons/chevron_right.svg#chevron_right-icon" />
          </svg>
        </a>
      </div>
    </section>
  </div>
</main>

<footer class="flex flex-column bg-primary px-4 pt-6">
  <div class="lg:w-11 xl:w-8 lg:align-self-center">
    <img src="logo.svg" alt="jobfixers logo" class="mb-3" />

    <section class="grid flex-column sm:flex-row justify-content-center sm:justify-content-between">
      <div class="col-fixed">
        <ul class="flex flex-column gap-2 m-0 pl-3">
          <li><a href="https://work.jobfixers.be">Jobs</a></li>
          <li><a href="https://join.jobfixers.be" target="_blank">Werken bij ons</a></li>
          <li><a href="https://www.jobfixers.be/nl/bedrijven">Voor werkgevers</a></li>
          <li><a href="https://www.jobfixers.be/nl/onze-kantoren">Vind een kantoor</a></li>
          <li><a href="https://www.jobfixers.be/nl/rally">Rally team</a></li>
          <li><a href="https://www.jobfixers.be/nl/contact">Contact</a></li>
        </ul>
      </div>

      <div class="flex flex-column gap-2 col-fixed">
        <a href="tel:09 210 09 09" target="_blank" class="text-lg contact-link">09 210 09 09</a>
        <a href="mailto:info@jobfixers.be" class="text-lg contact-link">info&#64;jobfixers.be</a>
        <div class="flex gap-3">
          <a href="https://www.facebook.com/JobFIXers.be/" target="_blank">
            <img
              src="https://shuttle-storage.s3.amazonaws.com/jobfixers2/Icons/Logo-Facebook.svg?1750675684"
          /></a>
          <a href="https://www.instagram.com/jobfixers/" target="_blank"
            ><img
              src="https://shuttle-storage.s3.amazonaws.com/jobfixers2/Icons/Logo%20Instagram.svg?1750675684"
          /></a>
          <a href="https://www.linkedin.com/company/jobfixers/" target="_blank"
            ><img
              src="https://shuttle-storage.s3.amazonaws.com/jobfixers2/Icons/Logo-LinkedIn.svg?1750675684"
          /></a>
        </div>
      </div>
    </section>

    <section class="flex flex-column text-xs text-center py-3">
      <span>
        © jobFIXers NV VL: VG.2191/UPC WAL: W.DISP.1297 BXL: 00505-406-20171128 jobFIXers construct
        NV
      </span>
      <span> VL: VG.2306/C WAL: W.INT.1675 BXL: 20209-406-20210625 BE 0701.657.517 </span>
      <span>
        <a href="https://www.jobfixers.be/nl/privacy-policy">Privacy Policy</a> -
        <a href="https://www.jobfixers.be/nl/algemene-voorwaarden">Algemene voorwaarden</a>
      </span>
    </section>
  </div>
</footer>

<p-drawer
  [(visible)]="isSidemenuOpened"
  [blockScroll]="true"
  position="right"
  styleClass="bg-primary border-primary"
>
  <ul class="list-none pl-3 m-0 flex flex-column gap-2 drawer-links-list">
    <li><a href="https://work.jobfixers.be">Jobs</a></li>
    <li><a href="https://join.jobfixers.be" target="_blank">Werken bij ons</a></li>
    <li><a href="https://www.jobfixers.be/nl/bedrijven">Voor werkgevers</a></li>
    <li><a href="https://www.jobfixers.be/nl/onze-kantoren">Vind een kantoor</a></li>
    <li><a href="https://www.jobfixers.be/nl/rally">Rally team</a></li>
    <li><a href="https://www.jobfixers.be/nl/contact">Contact</a></li>
  </ul>
</p-drawer>
